import { AlloyLegacyThemeDesignTokens, ModalDesignTokens } from '../types';
import { WeaveTheme } from '../types/weaveTypes';

type WeaveTokens = WeaveTheme['tokens'];

export const getModalComponentTokensAlloy = (
  theme: AlloyLegacyThemeDesignTokens,
  fontFamily: string,
): ModalDesignTokens => {
  return {
    'font-family': fontFamily,
    'background-color': theme.tokens.colors.background.primary.value,
    'border-radius': theme.borderRadius.medium,
    'box-shadow': 'rgba(0, 0, 0, 0.25) 0px 0px 8px 0px',
    'header-container': {
      'padding-top': '20px',
      'padding-right': `${theme.spacing.L}px`,
      'padding-bottom': '20px',
      'padding-left': `${theme.spacing.L}px`,
    },
    header: {
      'text-color': theme.tokens.colors.text.primary.value,
      'border-color': theme.tokens.colors.border.subtle.value,
      'min-height': 70,
    },
    child: {
      'padding-top': '10px',
      'padding-right': `${theme.spacing.L}px`,
      'padding-bottom': '10px',
      'padding-left': `${theme.spacing.L}px`,
    },
    'actions-container': {
      'padding-top': `${theme.spacing.M}px`,
      'padding-right': `${theme.spacing.L}px`,
      'padding-bottom': `${theme.spacing.M}px`,
      'padding-left': `${theme.spacing.L}px`,
      'border-color': theme.tokens.colors.border.subtle.value,
    },
    'close-button': {
      'margin-top': `${theme.spacing.XXS}px`,
    },
    light: {
      overlay: {
        'background-color': theme.colors.darkBlue900Alpha45,
      },
    },
    dark: {
      overlay: {
        'background-color': theme.colors.darkBlue900Alpha45,
      },
    },
    arrow: {
      'icon-color': theme.tokens.colors.icon.inverse.value,
    },
  };
};

export const getModalComponentTokensWeave = (
  tokens: WeaveTokens,
  fontFamily: string,
): ModalDesignTokens => {
  const semantic = tokens?.semantic;
  const generic = tokens?.generic;
  const modalTokens = tokens?.component?.modal;
  return {
    ...modalTokens,
    'font-family': fontFamily,
    header: {
      ...modalTokens?.header,
      'text-color': semantic?.['text-color']?.medium?.default,
      'border-color': semantic?.['border-color']?.divider?.light,
      'min-height': 72,
    },
    child: {
      ...modalTokens?.child,
      'text-color': semantic?.['text-color']?.medium?.default,
    },
    'actions-container': {
      ...modalTokens?.['actions-container'],
      'border-color': semantic?.['border-color']?.divider?.light,
    },
    arrow: {
      'icon-color': generic?.color?.white?.['100'],
    },
  };
};
